module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_vestland_neg.a3ed28e7.pdf";